import React from 'react';
import './CompContactWidget.css'; // Import the CSS file for styling
import { Button } from '@mui/material'; // Import Material-UI Button

const CompContactWidget = () => {
    return (
        <div style={{ width: '100%', margin: '16px 0', display: 'flex', justifyContent: 'center', paddingTop: '16px', paddingBottom: '16px' }}>
            <a href="/contact"><Button variant="outlined" style={{ background: 'white' }}>Contact Us Now</Button></a>
        </div>
    );
};

export default CompContactWidget;
